import { c as _c } from "react/compiler-runtime";
import { useFeatureFlag, FeatureFlagControlPanelProvider, AppScopeEnum } from '@newfront-insurance/admin-ui';
import { CoverageDslProvider } from '@newfront-insurance/admin-ui/coverage';
import { FallbackSuspense } from '@newfront-insurance/admin-ui/layout';
import { ChatOverlayProviderV2 } from '@newfront-insurance/nova-core';
import type { QueryObserverOptions } from '@tanstack/react-query';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode, JSX } from 'react';
import { AccountUIProvider } from './account-ui-api';
import { AdminUIProvider, useAppConfig } from './admin-ui';
import { AccountsCoverageApiProvider } from './coverage-api';
import { IncompleteUserErrorProvider } from './incomplete-user-error-provider';
import { PostLoginRedirectProvider } from './post-login-redirect';
import { AuthProvider } from '@/client/providers/auth';
import { SnowfallProvider } from '@/client/providers/snowfall-provider';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: (_error, query) => {
        return !query.state.data && (query.options as QueryObserverOptions).suspense === true;
      }
    }
  }
});
interface Props {
  children: ReactNode;
}
export function ReactQueryProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
/**
 * Compose all providers together into a single component
 */
export function Providers(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const isShowingDarkSidebar = useFeatureFlag("dark-navigator-sidebar", false);
  const appConfig = useAppConfig();
  const t1 = !appConfig;
  let t2;
  if ($[0] !== children) {
    t2 = <SnowfallProvider>{children}</SnowfallProvider>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <PostLoginRedirectProvider><FeatureFlagControlPanelProvider appScope={AppScopeEnum.ADMIN_NAVIGATOR} authProvider={AuthProvider}><AccountsCoverageApiProvider><CoverageDslProvider><ChatOverlayProviderV2 authProvider={AuthProvider} transparentFloatingButton={t1}>{t2}</ChatOverlayProviderV2></CoverageDslProvider></AccountsCoverageApiProvider></FeatureFlagControlPanelProvider></PostLoginRedirectProvider>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isShowingDarkSidebar || $[6] !== t3) {
    t4 = <FallbackSuspense><IncompleteUserErrorProvider><AccountUIProvider><AdminUIProvider isShowingDarkSidebar={isShowingDarkSidebar}>{t3}</AdminUIProvider></AccountUIProvider></IncompleteUserErrorProvider></FallbackSuspense>;
    $[5] = isShowingDarkSidebar;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}